// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3iz16","addWidgetButton":"Header_addWidgetButton__3UpeZ","dashboardTabs":"Header_dashboardTabs__2Jjm3","active":"Header_active__1cqcH"};